export const GLOBAL_PREFIX = 'api';
export const MICROSERVICE_MESSAGE_PREFIX = 'message';
export const API_URL = Symbol('api_url');
export const BASE_URL = `${GLOBAL_PREFIX}/${MICROSERVICE_MESSAGE_PREFIX}`;
export const MICROSERVICE_MESSAGE_WITH_ROUTING_PATTERN = 'MICROSERVICE_MESSAGE_WITH_ROUTING_PATTERN';
export const MICROSERVICE_EVENT_WITH_ROUTING_PATTERN = 'MICROSERVICE_EVENT_WITH_ROUTING_PATTERN';
